import { useCallback } from 'react';
import { LOCAL_ACCOUNTS_BASE_URL } from '../consts';
import { usePost, UsePostParams } from '../../../../api';

interface ExcludeTillPayload {
    excludeTill: Date;
}

export interface ExcludeLocalAccountsPayload extends ExcludeTillPayload {
    localAccountGuids: string[];
}

export type ExcludeLocalAccountsResponse = ExcludeTillPayload;
export type ExcludeLocalAccountsError = unknown;

export type UseExcludeLocalAccountsParams = UsePostParams<
    ExcludeLocalAccountsPayload,
    ExcludeLocalAccountsResponse,
    ExcludeLocalAccountsError
>;

export const useExcludeLocalAccounts = (params: UseExcludeLocalAccountsParams = {}) => {
    const { post, ...rest } = usePost<
        ExcludeLocalAccountsPayload,
        ExcludeLocalAccountsResponse,
        ExcludeLocalAccountsError
    >(params);

    const excludeLocalAccounts = useCallback(
        (localAccountGuids: string[], excludeTill: Date) =>
            post(`${LOCAL_ACCOUNTS_BASE_URL}/exclude`, {
                localAccountGuids,
                excludeTill
            }),
        [post]
    );

    return {
        ...rest,
        excludeLocalAccounts
    };
};

export default useExcludeLocalAccounts;
